import { Component, HostListener, Input, ElementRef, Output, EventEmitter } from '@angular/core';

interface InputListModel {
  value: string;
  name: string;
}

@Component({
  selector: 'app-dropdown-input-list',
  templateUrl: './dropdown-input-list.component.html',
  styleUrls: ['./dropdown-input-list.component.scss']
})
export class DropdownInputListComponent {
  @Input() currentValue: InputListModel = {
    value: '',
    name: ''
  };
  @Input() isOpen = false;
  @Input() label = '';
  @Input() list: string[] = [];
  @Input() dropdownID = 'dropdown-radios';
  @Output() closeModal = new EventEmitter<boolean>();
  @Output() valueChange = new EventEmitter<InputListModel>();
  @Output() cleanValue = new EventEmitter<void>();

  constructor(private eRef: ElementRef) { }

  @HostListener('document:click', ['$event'])

  onClick(ev) {
    if (this.isOpen) {
      if (!this.eRef.nativeElement.contains(ev.target)) {
        this.isOpen = false;
      }
    }
  }

  changeValue() {
    this.valueChange.emit(this.currentValue);
  }

  close() {
    this.isOpen = false;
    this.closeModal.emit(this.isOpen);
    this.valueChange.emit(this.currentValue);
  }

  clearValue(ev) {
    ev.stopPropagation();
    this.currentValue = {
      value: '',
      name: ''
    };
    this.cleanValue.emit();
  }

  closeDropDown() {
    this.isOpen = !this.isOpen;
  }

}
